export default __webpack_public_path__ + "static/media/033-family.9dcf980d.svg";